import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemLsName} from '../LS/FormChooseLs.jsx'
import Model from './ModelLsi.mjs'

export const FormItemLsiName = props => (
    <FormItemBizProp
        Model={Model}
        prop="lsiName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemLsiNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="lsiNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseLsi(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemLsName />
            <FormItemLsiNo />
            <FormItemLsiName />
        </FormChooseDesign>
    )
}
